<div class="select-meta">
  <div class="row">
    <app-text [formGroup]="$safeNavigationMigration(model()?.meta?.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.label)" [meta]="metaLabel"></app-text>
  </div>
  <div class="row">
    <app-text [formGroup]="$safeNavigationMigration(model()?.meta?.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.value)" [meta]="metaValue"></app-text>
  </div>
  <div class="row">
    <app-toggle [formGroup]="$safeNavigationMigration(model()?.meta?.formGroup)" [model]="$safeNavigationMigration(model()?.type?.data?.multiple)" [meta]="metaMultiple"></app-toggle>
  </div>
</div>
